import GridFilter from "@/lib/components/VDataGridV2/GridFilter";
import Loader     from "@/core/misc/Loader";

/**
 * Типовые фильтры колонок VDataGridV2. Имя отправляемого параметра заодно служит
 * id колонки, если он не задан явно.
 * Каждое обращение отдаёт новый фильтр со своим лоадером — открытые одновременно реестры
 * не делят между собой состояние поиска.
 *
 * @example
 * <VDataGridColumnV2 :filter="$core.filters.seller" />
 */
export default class Filters {

  /** Поставщик — на сервер уходит партнёр целиком под именем seller. */
  static get seller(): GridFilter {
    return new GridFilter(
      'select',
      {
        data:        Loader.sellers(),
        placeholder: 'Название партнера',
        clearable:   true,
      },
      'seller',
      '*',
    );
  }

  /** Покупатель — на сервер уходит партнёр целиком под именем buyer. */
  static get buyer(): GridFilter {
    return new GridFilter(
      'select',
      {
        data:        Loader.buyers(),
        placeholder: 'Название партнера',
        clearable:   true,
      },
      'buyer',
      '*',
    );
  }

  /** Номер документа — подстрока в номере, параметр idPattern. */
  static get idPattern(): GridFilter {
    return new GridFilter(
      'text',
      {
        placeholder: '№',
        clearable:   true,
      },
      'idPattern',
    );
  }

  /** Название — подстрока в названии, параметр pattern. */
  static get pattern(): GridFilter {
    return new GridFilter(
      'text',
      {
        placeholder: 'Название',
        clearable:   true,
      },
      'pattern',
    );
  }

  /** Период по дате — имя параметра у каждого реестра своё, поэтому передаётся явно. */
  static period(sendName: string, placeholder: string = 'Введите диапазон'): GridFilter {
    return new GridFilter(
      'date-range',
      {
        placeholder: placeholder,
        clearable:   true,
      },
      sendName,
    );
  }
}
